import { isEntityLoading, isEntityNotLoaded } from '@/Models/Entity';
import { useWorklistsDashboardStoreContext } from '@/Stores/WorklistsDashboard/WorklistsDashboardStoreContext';
import { observer } from 'mobx-react-lite';
import WorklistDashboardTicker from './WorklistDashboardTicker';
import Styles from './WorklistsDashboard.module.scss';
import { useMemo } from 'react';

const {
    dashboard: dashboardStyle,
} = Styles;

const WorklistsDashboard = (): React.ReactElement => {
    const worklistsDashboardStore = useWorklistsDashboardStoreContext();

    const dashboardState = worklistsDashboardStore.state;

    const tickers = useMemo(() => {
        if (isEntityNotLoaded(dashboardState) || isEntityLoading(dashboardState)) {
            return [];
        }

        return dashboardState.WorklistsDashboardTickers;
    }, [dashboardState]);

    const tickerElements = tickers.map((ticker) => (
        <WorklistDashboardTicker
            key={ticker.Info.CustomWorklistID}
            abbreviation={ticker.Info.Abbreviation}
            highThreshold={ticker.Info.HighThreshold}
            mediumThreshold={ticker.Info.MediumThreshold}
            resultCountOverflow={ticker.IsOverflow}
            resultCount={ticker.ResultCount}
            worklistID={ticker.Info.CustomWorklistID}
            worklistName={ticker.Info.CustomWorklistName}
            worklistDescription={ticker.Info.CustomWorklistDescription}
        />
    ));

    return (
        <div className={dashboardStyle}>
            {tickerElements}
        </div>
    );
};

export default observer(WorklistsDashboard);
